module.exports = __webpack_public_path__ + "img/not-found.f2f24fcf.svg";